import { BTbody } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTbody = createEgBootstrapProxy("EgBTbody", BTbody);
